import { render, staticRenderFns } from "./OnlineOrderForm.vue?vue&type=template&id=35867353&scoped=true&"
import script from "./OnlineOrderForm.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35867353",
  null
  
)

export default component.exports